<template>
<section class="section py-7">
  <div class="columns">
    <div class="card column is-half is-offset-one-quarter has-background-light has-shadow">
      <Auth :redirect="{name: 'root'}" :stage="stage"/>
    </div>
  </div>
</section>
</template>


<script>
import { mapState, mapActions } from 'pinia'
import { useLogin  } from '@/js/auth.js'

import Auth from '@/components/auth/Auth.vue'

export default {
    name: 'LoginView',
    components: { Auth },
    props: ["stage"],
    computed: {
        ...mapState(useLogin, ["isLogged"]),
    },
}
</script>
